module.exports = __webpack_public_path__ + "img/retail_tiny.e5e161e5.png";